import withConfigTransport from '../../services/config-transport/withConfigTransport'
import _VaTimeInput from './VaTimeInput.vue'

export const VaTimeInput = withConfigTransport(_VaTimeInput)
